import { formatNumber } from 'devextreme/localization';
import { Pipe, PipeTransform } from '@angular/core';
import { FrameworkService } from '@m4u-angular/core/framework/framework.service';

@Pipe({
    name: 'formatPriceWithCurrency'
})
export class FormatPriceWithCurrencyPipe implements PipeTransform 
{
    constructor(private framework: FrameworkService) { }

    transform(value: number, currency: string = null, isShowZero: boolean = false): string 
    {
        let result = '';

        if(value == null) value = 0;
        if(value == 0 && !isShowZero) return result;

        result = formatNumber(value, this.framework.CompanyInfo.NumberSum);
        if(currency != null)
        {
            result += ' ' + currency;
        }

        return result;
    }

}
